import ModelBase from "../../../../framework/core/mvvm/model_base";
import TableBaseModel from "../../../table/module/table_base/table_base_model";

const {ccclass, property} = cc._decorator;

@ccclass
export class JdPokerModel extends TableBaseModel {
    
   
}
